import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "place/type-environment"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getById(id){
        return http.getById(path,id,true)
    }

}

export default new service();

